import {
  selectUserEmail,
  selectUserProfileName,
  selectUserProfileStatus,
} from '@app/store/selectors';
import { useAppSelector } from '@app/store/store';
import { FullscreenModal } from '@hopin-team/component-fullscreen-modal';
import { useDashboardReactiveMap } from '@hopin-team/dashboard-shared-react';
import { useTranslation } from '@hopin-team/provider-translation';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const ContentContainer = styled.div`
  max-width: 1160px;
  margin: 0px auto;
  height: 100%;
`;

export const ManageProfileModal: React.FC = ({ children }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const profileName = useAppSelector(selectUserProfileName);
  const email = useAppSelector(selectUserEmail);
  const status = useAppSelector(selectUserProfileStatus);
  const fetching = status === 'processing' || !profileName;
  const title = fetching
    ? t('attendeeProfile.title')
    : `${t('attendeeProfile.title')} - ${profileName}`;

  const reactiveMap = useDashboardReactiveMap();

  useEffect(() => {
    if (!email) return;

    reactiveMap.getMapContext('launchdarkly_client').then(client => {
      if (!client) return;

      const currentContext = client.getContext();
      const emailDomain = email.split('@')[1];

      client.identify({
        ...currentContext,
        emailDomain,
        custom: {
          ...currentContext.custom,
        },
      });
    });
  }, [reactiveMap, email]);

  return (
    <FullscreenModal
      title={title}
      backButton={{
        onClick: () => {
          navigate('../');
        },
        isOutlined: true,
        isRound: true,
        size: 'small',
        title: t('manageOrganizationModal.close'),
      }}
      isDismissible={false}
    >
      <ContentContainer>{children}</ContentContainer>
    </FullscreenModal>
  );
};
